import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Icon,
  Input,
  useDisclosure,
  useToast,
} from '@chakra-ui/react'
import { useRef } from 'react'
import { BsFillTrashFill } from 'react-icons/bs'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useMutation, useQueryClient } from 'react-query'
import { api } from '../../../../services/api'
import { user } from '../../../../helpers/user'

const schema = yup.object().shape({
  code: yup.string().required('Código obrigatório'),
})

export function DeleteImage({ selectedField }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = useRef()

  const queryClient = useQueryClient()
  const toast = useToast()

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  })

  const type = selectedField === 'innovationBrindes' ? 2 : 1

  console.log(type)

  const codUsu = user?.codigo_usuario

  const { mutateAsync } = useMutation(
    async (data) => {
      const response = await api.delete(
        `/site/v2/fluxo-imagem/deletar-imagens-produto/${data.code}/${codUsu}/${type}`
      )

      return response.data
    },
    {
      onSuccess: () => {
        toast({
          title: 'Imagem deletada com sucesso',
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        })
        queryClient.invalidateQueries('images-upload-production')
        onClose()
        reset()
      },
      onError: () => {
        toast({
          title: 'Erro ao deletar imagem',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        })
      },
    }
  )

  async function handleDeleteImage(data) {
    await mutateAsync(data)
  }

  const label =
    selectedField === 'innovationBrindes'
      ? 'Innovation Brindes'
      : 'Innovation Store'

  return (
    <>
      <Button colorScheme="red" onClick={onOpen}>
        <Icon as={BsFillTrashFill} mr="2" />
        Deletar existente - {label}
      </Button>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Deletar imagem - {label}
            </AlertDialogHeader>

            <AlertDialogBody>
              <form>
                <Input
                  placeholder="Digite o código do produto"
                  {...register('code')}
                />
              </form>

              {errors.code && (
                <span style={{ color: 'red' }}>{errors.code.message}</span>
              )}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancelar
              </Button>
              <Button
                colorScheme="red"
                onClick={handleSubmit(handleDeleteImage)}
                ml={3}
              >
                Deletar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
